<!-- TODO some default icon if name/collection not provided ? -->
@if (collection && name) {
  <i [ngClass]="[collection, name]"></i>
}
